module.exports = __webpack_public_path__ + "static/media/SumoTouchArea.a5592aed.png";